var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEocean(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "eOcean",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 28 Q 50 13 90 26 Q 50 37 10 28 Z",
    fill: "#2D6CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 28 Q 30 33 49 30 Q 31 38 10 28 Z",
    fill: "#41C0E8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 50 Q 50 35 94 48 Q 50 61 6 50 Z",
    fill: "#2D6CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 48 Q 73 54 55 50 Q 74 57 94 48 Z",
    fill: "#41C0E8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 72 Q 50 59 90 72 Q 50 85 10 72 Z",
    fill: "#2D6CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 72 Q 30 77 49 74 Q 31 82 10 72 Z",
    fill: "#41C0E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEocean);
export default __webpack_public_path__ + "static/media/eocean.eb28ddd96fad532d4ba1d81d23ee756c.svg";
export { ForwardRef as ReactComponent };